module.exports = __webpack_public_path__ + "static/media/member (6).1e051333.png";